/**
 * Styles.
 */
import './body.scss';
import './header.css';
import './style.scss';

/**
 * External Dependencies
 */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { showSocketConnectionRetryAlertMessage } from '../../../utils/alert';
import { getRetryUrl } from '../../../utils/socket-io';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../../components/async-component';

/**
 * Component
 */
const DisplayLive = () => {
  const [loading, setLoading] = useState(true);
  const [autorizzato, setAutorizzato] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const checkDisplayConnesso = useCallback(displayId => {
    const currentUrl = new URL(window.location);
    const forceSocketConnection = currentUrl.searchParams.get(
      'forceSocketConnection'
    );
    window.api.display
      .checkConnesso(displayId, forceSocketConnection)
      .then(res => {
        const connessioneNonDisponibile = res.data.connesso;
        if (connessioneNonDisponibile) {
          showSocketConnectionRetryAlertMessage('Display già in uso', 10).then(
            () => {
              const retryUrl = getRetryUrl(currentUrl);
              window.location.assign(retryUrl);
            }
          );
        } else {
          if (currentUrl.searchParams.has('forceSocketConnection')) {
            currentUrl.searchParams.delete('forceSocketConnection');
            window.location.assign(currentUrl);
          }

          if (window.socket.connected) {
            window.socket.emit('display-hello', displayId);
          }
          window.socket.on('connect', () => {
            window.socket.emit('display-hello', displayId);
          });
          window.socket.on('riavvio', () => {
            window.location.reload();
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      setAutorizzato(true);
      setLoading(false);
      checkDisplayConnesso(id);
    } else {
      navigate('/');
    }
  }, [id, navigate, checkDisplayConnesso]);

  return (
    <div>
      {!loading ? (
        autorizzato ? (
          <AsyncComponent component={() => import('./content')} />
        ) : (
          <div className="rui-sign align-items-center justify-content-center">
            <p className="display-4 mb-30">Credenziali Display Errate</p>
          </div>
        )
      ) : (
        <div className="rui-sign align-items-center justify-content-center">
          <p className="display-4 mb-30">Caricamento...</p>
        </div>
      )}
    </div>
  );
};

export default DisplayLive;
